import {
  EnumerationsAnalysisCategory,
  EnumerationsAnalysisType,
  EnumerationsProportionalAnalyses,
} from 'client/sratool'

export const nonCompetitiveMovementsTypes: EnumerationsProportionalAnalyses[] =
  [
    EnumerationsProportionalAnalyses.NonCompetitivePromotionsAnalysis,
    EnumerationsProportionalAnalyses.AllTerminationsAnalysis,
    EnumerationsProportionalAnalyses.VoluntaryTerminationsAnalysis,
    EnumerationsProportionalAnalyses.InvoluntaryTerminationsAnalysis,
  ]

export const applicantFlowTypes: EnumerationsProportionalAnalyses[] = [
  EnumerationsProportionalAnalyses.ApplicantPoolVsLaborMarket,
]

export const laborMarketTypes: EnumerationsProportionalAnalyses[] = [
  EnumerationsProportionalAnalyses.ApplicantPoolVsLaborMarket,
  EnumerationsProportionalAnalyses.WorkforceVsLaborMarket,
]

export const isSelectionRateAnalysisType = <
  T extends { analysisCategoryID: EnumerationsAnalysisCategory }
>(
  a: T
): boolean =>
  a.analysisCategoryID === EnumerationsAnalysisCategory.SelectionRateAnalysis

export const isNonCompetitiveMovementsAnalysisType = <
  T extends {
    analysisCategoryID: EnumerationsAnalysisCategory
    proportionalAnalysisID: EnumerationsProportionalAnalyses
  }
>(
  a: T
) => {
  return (
    a.analysisCategoryID ===
      EnumerationsAnalysisCategory.ProportionalAnalysis &&
    nonCompetitiveMovementsTypes.includes(a.proportionalAnalysisID)
  )
}

export const isApplicantFlowAnalysisType = <
  T extends {
    analysisCategoryID: EnumerationsAnalysisCategory
    proportionalAnalysisID: EnumerationsProportionalAnalyses
  }
>(
  a: T
) =>
  a.analysisCategoryID === EnumerationsAnalysisCategory.ProportionalAnalysis &&
  applicantFlowTypes.includes(a.proportionalAnalysisID)

export const isLaborMarketAnalysisType = <
  T extends {
    analysisCategoryID: EnumerationsAnalysisCategory
    proportionalAnalysisID: EnumerationsProportionalAnalyses
  }
>(
  a: T
) =>
  a.analysisCategoryID === EnumerationsAnalysisCategory.ProportionalAnalysis &&
  laborMarketTypes.includes(a.proportionalAnalysisID)

export const isSraHiringAnalysisType = <
  T extends {
    analysisTypeID: EnumerationsAnalysisType
  }
>(
  a: T
) => {
  return a.analysisTypeID === EnumerationsAnalysisType.ApplicantsVsHires
}
export const isCompetitivePromotionsAnalysisType = <
  T extends {
    analysisTypeID: EnumerationsAnalysisType
  }
>(
  a: T
) => {
  return (
    a.analysisTypeID ===
    EnumerationsAnalysisType.ApplicantsVsCompetitivePromotions
  )
}
export const isTotalSelectionsAnalysisType = <
  T extends {
    analysisTypeID: EnumerationsAnalysisType
  }
>(
  a: T
) => {
  return a.analysisTypeID === EnumerationsAnalysisType.TotalSelections
}
